// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */
/* SAM (Smart Analyst for Markets) — News Feed Styles */

.news-panel {
  height: 100%;
  overflow-y: auto;
  padding: 12px;
  background: var(--bg);
  color: var(--text);
  display: flex;
  flex-direction: column;
}

.news-header { margin-bottom: 10px; }

.news-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.news-title-row h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.news-overall {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}
.news-overall.bullish { background: rgba(34, 197, 94, 0.15); color: #22c55e; }
.news-overall.bearish { background: rgba(239, 68, 68, 0.15); color: #ef4444; }
.news-overall.neutral { background: rgba(100, 116, 139, 0.15); color: #94a3b8; }

.news-sentiment-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
  font-size: 11px;
}
.news-sent-item { color: var(--text-dim); }
.news-sent-item.pos { color: #22c55e; }
.news-sent-item.neg { color: #ef4444; }
.news-sent-item.neu { color: #94a3b8; }

.news-refresh {
  margin-left: auto;
  padding: 3px 10px;
  font-size: 11px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.news-refresh:disabled { opacity: 0.5; cursor: not-allowed; }

/* ─── Filters ─────────────────────────────────────────────────── */
.news-filters {
  display: flex;
  gap: 0;
  margin-bottom: 10px;
  border-bottom: 1px solid var(--border);
}
.news-filter {
  padding: 6px 14px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-dim);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.15s;
}
.news-filter:hover { color: var(--text); }
.news-filter.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

/* ─── News List ───────────────────────────────────────────────── */
.news-list {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.news-loading, .news-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: var(--text-dim);
  font-size: 13px;
}

.news-item {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 6px;
  text-decoration: none;
  color: var(--text);
  border-left: 3px solid transparent;
  transition: background 0.15s;
}
.news-item:hover { background: var(--card); }
.news-positive { border-left-color: #22c55e; }
.news-negative { border-left-color: #ef4444; }
.news-neutral { border-left-color: var(--border); }

.news-item-left {
  padding-top: 4px;
  flex-shrink: 0;
}

.news-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.news-dot.positive { background: #22c55e; box-shadow: 0 0 4px rgba(34, 197, 94, 0.4); }
.news-dot.negative { background: #ef4444; box-shadow: 0 0 4px rgba(239, 68, 68, 0.4); }
.news-dot.neutral { background: #64748b; }

.news-item-body { flex: 1 1; min-width: 0; }

.news-headline {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.news-source {
  font-size: 11px;
  color: var(--text-dim);
  font-weight: 600;
}
.news-time {
  font-size: 10px;
  color: var(--text-dim);
}
.news-ticker {
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 3px;
  background: var(--border);
  color: var(--text);
}
.news-ticker-portfolio {
  background: rgba(59, 130, 246, 0.15);
  color: var(--accent);
}
.news-portfolio-badge {
  font-size: 9px;
  font-weight: 700;
  padding: 1px 4px;
  border-radius: 3px;
  background: rgba(59, 130, 246, 0.1);
  color: var(--accent);
  letter-spacing: 0.5px;
}

/* ─── Mobile ──────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .news-panel { padding: 8px; }
  .news-filters { overflow-x: auto; }
  .news-headline { font-size: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/NewsFeed.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF,uDAAuD;;AAEvD;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe,mBAAmB,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA,wBAAwB,mCAAmC,EAAE,cAAc,EAAE;AAC7E,wBAAwB,mCAAmC,EAAE,cAAc,EAAE;AAC7E,wBAAwB,qCAAqC,EAAE,cAAc,EAAE;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA,kBAAkB,sBAAsB,EAAE;AAC1C,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,cAAc,EAAE;;AAEtC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D,oEAAoE;AACpE;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,qBAAqB;AACvB;AACA,qBAAqB,kBAAkB,EAAE;AACzC;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,oEAAoE;AACpE;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;AACA,mBAAmB,uBAAuB,EAAE;AAC5C,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,0BAA0B,EAAE;AAC7C,gBAAgB,gCAAgC,EAAE;;AAElD;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA,qBAAqB,mBAAmB,EAAE,0CAA0C,EAAE;AACtF,qBAAqB,mBAAmB,EAAE,0CAA0C,EAAE;AACtF,oBAAoB,mBAAmB,EAAE;;AAEzC,kBAAkB,SAAO,EAAE,YAAY,EAAE;;AAEzC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,cAAc,YAAY,EAAE;EAC5B,gBAAgB,gBAAgB,EAAE;EAClC,iBAAiB,eAAe,EAAE;AACpC","sourcesContent":["/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */\n/* SAM (Smart Analyst for Markets) — News Feed Styles */\n\n.news-panel {\n  height: 100%;\n  overflow-y: auto;\n  padding: 12px;\n  background: var(--bg);\n  color: var(--text);\n  display: flex;\n  flex-direction: column;\n}\n\n.news-header { margin-bottom: 10px; }\n\n.news-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.news-title-row h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.news-overall {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n}\n.news-overall.bullish { background: rgba(34, 197, 94, 0.15); color: #22c55e; }\n.news-overall.bearish { background: rgba(239, 68, 68, 0.15); color: #ef4444; }\n.news-overall.neutral { background: rgba(100, 116, 139, 0.15); color: #94a3b8; }\n\n.news-sentiment-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 6px;\n  font-size: 11px;\n}\n.news-sent-item { color: var(--text-dim); }\n.news-sent-item.pos { color: #22c55e; }\n.news-sent-item.neg { color: #ef4444; }\n.news-sent-item.neu { color: #94a3b8; }\n\n.news-refresh {\n  margin-left: auto;\n  padding: 3px 10px;\n  font-size: 11px;\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.news-refresh:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ─── Filters ─────────────────────────────────────────────────── */\n.news-filters {\n  display: flex;\n  gap: 0;\n  margin-bottom: 10px;\n  border-bottom: 1px solid var(--border);\n}\n.news-filter {\n  padding: 6px 14px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-dim);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.news-filter:hover { color: var(--text); }\n.news-filter.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n/* ─── News List ───────────────────────────────────────────────── */\n.news-list {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.news-loading, .news-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n  color: var(--text-dim);\n  font-size: 13px;\n}\n\n.news-item {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 6px;\n  text-decoration: none;\n  color: var(--text);\n  border-left: 3px solid transparent;\n  transition: background 0.15s;\n}\n.news-item:hover { background: var(--card); }\n.news-positive { border-left-color: #22c55e; }\n.news-negative { border-left-color: #ef4444; }\n.news-neutral { border-left-color: var(--border); }\n\n.news-item-left {\n  padding-top: 4px;\n  flex-shrink: 0;\n}\n\n.news-dot {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n.news-dot.positive { background: #22c55e; box-shadow: 0 0 4px rgba(34, 197, 94, 0.4); }\n.news-dot.negative { background: #ef4444; box-shadow: 0 0 4px rgba(239, 68, 68, 0.4); }\n.news-dot.neutral { background: #64748b; }\n\n.news-item-body { flex: 1; min-width: 0; }\n\n.news-headline {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.4;\n  margin-bottom: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.news-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.news-source {\n  font-size: 11px;\n  color: var(--text-dim);\n  font-weight: 600;\n}\n.news-time {\n  font-size: 10px;\n  color: var(--text-dim);\n}\n.news-ticker {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 1px 5px;\n  border-radius: 3px;\n  background: var(--border);\n  color: var(--text);\n}\n.news-ticker-portfolio {\n  background: rgba(59, 130, 246, 0.15);\n  color: var(--accent);\n}\n.news-portfolio-badge {\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 4px;\n  border-radius: 3px;\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--accent);\n  letter-spacing: 0.5px;\n}\n\n/* ─── Mobile ──────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .news-panel { padding: 8px; }\n  .news-filters { overflow-x: auto; }\n  .news-headline { font-size: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
